import { Injectable } from '@angular/core';
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

@Injectable()
export class FormUtilsService {
  validators: { [key: string]: ValidatorFn } = {
    noBlank: Validators.pattern(/^(?!\s*$).+/),
    number: Validators.pattern('^[0-9]+$'),
    password: Validators.pattern(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&:;_])[A-Za-z\d@$!%*#?&:;_]+$/
    ),
  };

  validatorGenerator: { [key: string]: (...any) => ValidatorFn } = {
    nameAlreadyExists: this.validateNameAlreadyExists,
  };

  formControlIsInvalid(form: UntypedFormGroup, formName: string): boolean {
    const formControl: AbstractControl = form.controls[formName];
    return formControl.invalid && (formControl.dirty || formControl.touched);
  }

  getErrorMessage(
    validationErrors: ValidationErrors,
    errorTypes: { error: string; message: string }[]
  ): string {
    return errorTypes.find(({ error }) => validationErrors[error])?.message;
  }

  formControlValidator(
    form: UntypedFormGroup,
    formName: string,
    validator: string
  ): boolean {
    return (
      this.formControlIsInvalid(form, formName) &&
      form.controls[formName].errors[validator]
    );
  }

  formIsInvalidAndTouched(
    form: UntypedFormGroup,
    formNames: string[]
  ): boolean {
    let isInvalid = false;
    formNames.map(formName => {
      isInvalid = isInvalid || this.formControlIsInvalid(form, formName);
    });
    return isInvalid;
  }

  private validateNameAlreadyExists(
    existingNames: any[],
    selected?: any
  ): ValidatorFn {
    return (input: UntypedFormControl): ValidationErrors | null => {
      const existingNamesWithoutSelected = existingNames.filter(
        value => selected !== value
      );

      if (existingNamesWithoutSelected.includes(input.value)) {
        return { alreadyExists: true };
      }
      return null;
    };
  }
}
